import CustomPrivacyHeading from "../common/CustomPrivacyHeading";
import { Link } from "react-router-dom";

const Privacy = () => {
  return (
    <div className="relative">
      <div className="max-w-[766px] max-lg:px-4 flex flex-col gap-10 max-md:gap-7 max-sm:gap-5 w-full mx-auto pt-[104px] pb-[130px] max-lg:py-24 max-md:py-16">
        <div>
          <h5 className="font-semibold text-[#010101] text-[28px] leading-[111%]">
            Introduction
          </h5>
          <p className="text-black/70 font-normal text-base max-max-sm:text-sm leading-[160%] pt-[15px] ff-sans">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
            placerat scelerisque tortor ornare ornare. Quisque placerat
            scelerisque tortor ornare ornare Convallis felis vitae tortor augue.
            Velit nascetur proin massa in. Consequat faucibus porttitor enim
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
            placerat scelerisque tortor ornare ornare. Quisque placerat
            scelerisque tortor ornare ornare Convallis felis vitae tortor augue.
          </p>
        </div>
        <div>
          <CustomPrivacyHeading text="1. Information We Collect" />
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            We may collect the following types of information:
          </p>
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            <span className="font-bold text-black pr-1">01</span>
            <span className="font-bold text-black pr-1">
              Personal Information:
            </span>
            email address, phone number, company name, and other contact details
            when you submit a form, request a quote, or communicate with us.
          </p>
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            <span className="font-bold text-black pr-1">02</span>
            <span className="font-bold text-black pr-1">Usage Data:</span>
            Pages visited, time spent on pages, browser type, and IP address,
            collected through analytics tools.
          </p>
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            <span className="font-bold text-black pr-1">03</span>
            <span className="font-bold text-black">Cookies & Tracking: </span>
            We use cookies and similar technologies to understand your
            preferences and enhance your experience.
          </p>
        </div>
        <div className="two">
          <CustomPrivacyHeading text="2. How We Use Your Information" />
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            We use your personal data for the following purposes:
          </p>
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            <span className="font-bold text-black pr-1">01</span>
            <span className="font-bold text-black pr-1">
              To Process Orders and Deliver Products:
            </span>
            email address, phone number, company name, and other contact details
            when you submit a form, request a quote, or communicate with us.
          </p>
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            <span className="font-bold text-black pr-1">02</span>
            <span className="font-bold text-black pr-1">
              To Communicate with You:
            </span>
            Pages visited, time spent on pages, browser type, and IP address,
            collected through analytics tools.
          </p>
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            <span className="font-bold text-black pr-1">03</span>
            <span className="font-bold text-black">
              To Improve Our Services:
            </span>
            We use cookies and similar technologies to understand your
            preferences and enhance your experience.
          </p>
        </div>
        <div className="three">
          <CustomPrivacyHeading text="3. Information Sharing" />
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          </p>
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            <span className="font-bold text-black pr-1">01</span>
            <span className="font-bold text-black pr-1">
              Trusted Service Partners:
            </span>
            email address, phone number, company name, and other contact details
            when you submit a form, request a quote, or communicate with us.
          </p>
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            <span className="font-bold text-black pr-1">02</span>
            <span className="font-bold text-black pr-1">
              Legal Authorities:
            </span>
            Pages visited, time spent on pages, browser type, and IP address,
            collected through analytics tools.
          </p>
        </div>
        <div>
          <CustomPrivacyHeading text="4. Your Choices & Rights" />
          <p className="ff-sans text-base leading-[160%] text-black/70">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
            placerat scelerisque tortor ornare ornare. Quisque placerat
            scelerisque tortor.
          </p>
        </div>
        <div className="four">
          <CustomPrivacyHeading text="5. Data Security" />
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
            placerat scelerisque tortor ornare ornare. Quisque placerat
            scelerisque tortor.
          </p>
        </div>
        <div className="five">
          <CustomPrivacyHeading text="6. Information Sharing" />
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          </p>
          <p className="font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            <span className="font-bold text-black pr-1">1</span>
            <span className="font-bold text-black pr-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </span>
          </p>
          <p className="font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            <span className="font-bold text-black pr-1">2</span>
            <span className="font-bold text-black pr-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </span>
          </p>
          <p className="font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            <span className="font-bold text-black pr-1">3</span>
            <span className="font-bold text-black pr-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </span>
          </p>
        </div>
        <div className="six">
          <CustomPrivacyHeading text="7. Updates to This Policy" />
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
            placerat scelerisque tortor ornare ornare. Quisque placerat
            scelerisque tortor.
          </p>
        </div>
        <div className="seven">
          <CustomPrivacyHeading text="8. Contact Us" />
          <p className="text-black/70 font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            If you have questions or concerns about this policy or your data,
            please reach out to us at:
          </p>
          <p className="text-black font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
            Email:{" "}
            <a
              href="mailto:support@tripnest.com"
              className="text-[#003086] text-base font-normal leading-[160%] border-b border-solid border-[#003086] pb-0.5 ff-sans"
            >
              support@tripnest.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
